<div><button (click)="onClick()">Click for error</button></div>
